var n={name:"dynamic-icon",props:{icon:{type:String,required:!0}},watch:{icon:{handler:function(n){this.$options.components[n]=function(){return import("../../icons/"+n+"/index.js")}},immediate:!0}}};export{n as default};
